// extracted by mini-css-extract-plugin
export var header = "_ct-0";